import { Component } from '@angular/core';
import { AuthService } from '../shared/auth-service/auth.service';
import { CustomDxfViewer } from '../shared/dxf/custom-dxf-viewer';
import { DxfViewerLoadParams } from 'dxf-viewer';
import { AppToastService } from '../shared/toast-service/toast-service';

@Component({
    selector: 'app-dxf-to-jpg',
    templateUrl: './dxf-to-jpg.component.html',
    styleUrls: ['./dxf-to-jpg.component.scss'],
    standalone: false
})
export class DxfToJpgComponent {
  public loggedIn!: boolean;
  title = 'Article Staging';
  displayError: boolean = false;
  errorMessage: string = '';
  hasFile: boolean = false;
  dxfFiles!: File[];
  jpgUrl: string | undefined;

  constructor(
    private authService: AuthService,
    private dxfViewer: CustomDxfViewer,
    private toastService: AppToastService
  ) {
  }

  ngOnInit(): void {
    this.loggedIn = this.isLoggedIn();
  }

  private isLoggedIn() {
    return !!this.authService.getToken();
  }

  public handleDxfUpload($event: any) {
    console.log('Event:', $event);
    this.displayError = false;
    const file = $event.target.files[0];
    console.log('File:', file);
    this.dxfFiles = file ? [file] : this.dxfFiles; // Wrap the file in an array
    if (this.dxfFiles) {
      this.hasFile = true;
      this.convertDxfToJpg(this.dxfFiles[0]); // Pass the first file in the array
    }
  }

  /**
   * Converts a DXF file to a JPG file.
    * @param dxfFiles The DXF file to convert.
    * @returns A promise that resolves when the conversion is complete.
    * @private
    */
  private async convertDxfToJpg(dxfFile: File) {
  this.displayError = false;
  this.errorMessage = '';

  try {
    // --------------------------
    // 1. Validate file existence
    // --------------------------
    if (!dxfFile) {
      this.displayError = true;
      this.errorMessage = 'No file selected.';
      return;
    }

    // --------------------------
    // 2. Validate DXF extension
    // --------------------------
    const fileName = dxfFile.name.toLowerCase();
    if (!fileName.endsWith('.dxf')) {
      this.toastService.show('Invalid file type. Please upload a valid DXF file.', { classname: 'bg-danger text-light', delay: 2000 });
      return;
    }

    // --------------------------
    // 3. File size validation (example: max 5MB)
    // --------------------------
    const maxSizeMB = 5;
    if (dxfFile.size > maxSizeMB * 1024 * 1024) {
      this.toastService.show(`File size exceeds ${maxSizeMB}MB limit.`, { classname: 'bg-danger text-light', delay: 2000 });
      return;
    }

    // --------------------------
    // 4. Convert to Blob URL
    // --------------------------
    const blobUrl = URL.createObjectURL(dxfFile);

    const dxfViewerLoadParams: DxfViewerLoadParams = {
      url: blobUrl,
      fonts: null,
      progressCbk: null,
      workerFactory: null
    };

    // --------------------------
    // 5. Await viewer load with error handling
    // --------------------------
    await this.dxfViewer.Load(dxfViewerLoadParams)
      .catch(err => {
        throw new Error('Failed to load DXF file. Please check if the file is valid.');
      });

    // --------------------------
    // 6. Convert to JPG
    // --------------------------
    const jpgData = this.dxfViewer.toDataURL('image/jpeg', 0.92);
    this.jpgUrl = jpgData;

  } catch (error: any) {
    // --------------------------
    // 7. Handle errors gracefully
    // --------------------------
    this.displayError = true;
    this.errorMessage = error?.message || 'An unexpected error occurred while converting DXF to JPG.';
    this.toastService.show(this.errorMessage, { classname: 'bg-danger text-light', delay: 2000 });
     
  }
}


  public logout() {
    this.authService.logout();
  }
}
